import { reactive } from "vue";
import { breakpointsTailwind, useBreakpoints as vueuseBreakpoints } from "@vueuse/core";


export function useBreakpoints() {
    return reactive(vueuseBreakpoints<keyof typeof breakpointsTailwind>(breakpointsTailwind))
}
